export default __webpack_public_path__ + "static/media/icon_parallel_coordinates.8126a9b6.svg";